import React from 'react';
import slider1 from '../assets/slider-1.png';
import slider12 from '../assets/slider-12.png';
import slider2 from '../assets/slider-2.png';
import slider22 from '../assets/slider-22.png';
import slider24 from '../assets/slider-24.png';
import slider25 from '../assets/slider-25.png';
import slider3 from '../assets/slider-3.png';
import slider32 from '../assets/slider-32.png';
import slider33 from '../assets/slider-33.png';
import {Link} from 'react-router-dom';

const Hero = () => {
    const slidesData = [
        {
            heading: 'MANAGE EVERYTHING FLUENTLY!',
            description: 'Manage students, faculties, courses, classes, and many more tasks with a simple software.',
            image: slider24,
            buttonText: 'Get a Quote'
        },
        {
            heading: 'FUEL FOR YOUR SCHOOL',
            description: 'Top of the line customizable cloud based and integrated educational ERP system.',
            image: slider25,
            buttonText: 'Get a Quote'
        },
        {
            heading: 'Build Your Website Today',
            description: 'We are building fast, stunning, and scalable websites. From concept to launch, we handle it all so you can focus on growth!',
            image: slider33,
            buttonText: 'Get a Quote'
        },
    ];

    return (
        <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-bs-ride="carousel"
            data-bs-interval="4000"
            style={{ height: '100vh' }}
        >
            {/* === Internal CSS === */}
            <style>{`
                .hero-heading {
                    font-size: 3.4rem;
                    animation: fadeUp 1s ease-out;
                    margin-bottom: 1rem;
                    margin-top: 2.8rem;
                    line-height: 1.3;
                }

                .hero-description {
                    font-size: 1rem;
                    animation: fadeUp 1.2s ease-out;
                    margin-bottom: 1.5rem;
                    max-width: 500px;
                }

                .hero-carousel-item {
                    height: 100vh;
                    background-size: cover;
                    background-position: center;
                }

                .content-overlay {
                    background-color: rgba(0, 0, 0, 0.50);
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: flex-start;
                    padding-top: 5rem;
                }

                .hero-content {
                    padding: 0 15px;
                }

                .hero-button {
                    font-size: 0.9rem;
                    padding: 0.75rem 1.5rem;
                }

                @keyframes fadeUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>

            {/* Indicators */}
            <div className="carousel-indicators">
                {slidesData.map((_, idx) => (
                    <button
                        key={idx}
                        type="button"
                        data-bs-target="#carouselExampleIndicators"
                        data-bs-slide-to={idx}
                        className={idx === 0 ? 'active' : ''}
                        aria-current={idx === 0 ? 'true' : undefined}
                        aria-label={`Slide ${idx + 1}`}
                    ></button>
                ))}
            </div>

            {/* Slides */}
            <div className="carousel-inner h-100 w-100">
                {slidesData.map((slide, idx) => (
                    <div 
                        className={`carousel-item hero-carousel-item ${idx === 0 ? 'active' : ''}`} 
                        key={idx}
                        style={{ backgroundImage: `url(${slide.image})` }}
                    >
                        <div className="content-overlay">
                            <div className="container hero-content">
                                <div className="row">
                                    <div className="col-lg-6 col-md-8 text-start text-white">
                                        <h1 className="fw-bold hero-heading">{slide.heading}</h1>
                                        <p className="hero-description">{slide.description}</p>
                                        <Link to="/contact-us">
                                            <button className="btn btn-light hero-button fw-semibold">
                                                {slide.buttonText}
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Controls */}
            <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide="prev"
                style={{ left: '-50px' }}
            >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide="next"
            >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    );
};

export default Hero;